import {
  ADD_ALARM,
  END_ALARM_LAUNCH,
  REMOVE_ALARM,
  START_ALARM_LAUNCH,
  SET_ALARMS,
  UPDATE_ALARM,
} from '../actions/actionTypes'

const initialState = {
  alarms: [],
  isLaunchingAlarm: null,
}

const alarmReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_ALARM:
      return {
        ...state,
        alarms: [action.payload, ...state.alarms],
      }

    case SET_ALARMS:
      return {
        ...state,
        alarms: action.payload,
      }

    case REMOVE_ALARM:
      return {
        ...state,
        alarms: state.alarms.filter(({ alarmInfo }) => alarmInfo.id !== action.payload),
      }

    case START_ALARM_LAUNCH:
      return { ...state, isLaunchingAlarm: action.payload }

    case END_ALARM_LAUNCH:
      return { ...state, isLaunchingAlarm: null }

    case UPDATE_ALARM:
      const updatedAlarms = [...state.alarms]
      const alarmToUpdateIndex = updatedAlarms.findIndex(
        ({ alarmInfo }) => alarmInfo.id === action.payload.alarmInfo.id
      )

      if (alarmToUpdateIndex === -1) return { ...state }

      updatedAlarms[alarmToUpdateIndex] = { ...action.payload }
      return { ...state, alarms: updatedAlarms }

    default:
      return { ...state }
  }
}

export default alarmReducer
